
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { Apollo } from '@/providers/Apollo.tsx';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((error) => {
      console.error('Service worker registration failed:', error);
    });
  });
}

createRoot(document.getElementById('root')!).render(
  <Apollo>
    <App />
  </Apollo>
);



